import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="paired-promotion-field"
export default class extends Controller {
  static targets = ["promotionSelect", "pairedField", "pairedInput"]
  static values = {
    promotionId: String
  }

  connect() {
    this.toggleField()
  }

  toggleField() {
    if (this.hasPromotionSelectTarget && this.hasPairedFieldTarget) {
      const selectedValue = this.promotionSelectTarget.value
      const shouldShow = selectedValue === this.promotionIdValue
      
      this.pairedFieldTarget.style.display = shouldShow ? 'block' : 'none'
      
      // Limpiar el campo cuando se oculta para evitar enviar valores fantasma
      if (!shouldShow && this.hasPairedInputTarget) {
        this.pairedInputTarget.value = ''
        this.pairedInputTarget.removeAttribute('required')
      } else if (shouldShow && this.hasPairedInputTarget) {
        this.pairedInputTarget.setAttribute('required', 'required')
      }
    }
  }
}
